export default {
  // check incoming call and current call
  validate({ commit }, payload = {}) {
    const { key } = payload
    const k = key

    delete payload.token
    return this.$axios
      .$post(`/api/v1/conferences/${k}/actions/validate`, payload)
      .then((data) => {
        return data
      })
  },

  get({ commit }, payload = {}) {
    const { key } = payload

    return this.$axios.$get(`/api/v1/conferences/${key}`).then((data) => {
      commit('SET_CONFERENCE', data)
      return data
    })
  },

  end({ commit }, payload) {
    const { callId } = payload

    return this.$axios
      .$patch(`/api/v1/calls/${callId}/actions/end-call`, payload)
      .then((data) => {
        return data
      })
  },

  saveChatLog({ commit }, payload = {}) {
    // OMG-6933: chats routes now require auth. In-call guests send the same
    // Basic guest:<conferenceId> credential already used for the S3 routes.
    const { key, ...body } = payload
    const basicAuth = window.btoa(`guest:${key}`)

    return this.$axios
      .$post(`/api/v1/chats/actions/cache`, body, {
        headers: {
          Authorization: `Basic ${basicAuth}`
        }
      })
      .then((data) => {
        return data
      })
  },

  fetchChatLogs({ commit }, payload = {}) {
    const { callId, roomId, key } = payload
    const basicAuth = window.btoa(`guest:${key}`)

    return this.$axios
      .$get(`/api/v1/chats/${callId}?roomId=${roomId}`, {
        headers: {
          Authorization: `Basic ${basicAuth}`
        }
      })
      .then((data) => {
        commit('SET_CHAT_LOGS', data)
        return data
      })
  },

  saveRating({ commit }, payload) {
    const { callId } = payload

    return this.$axios
      .$patch(`/api/v1/calls/${callId}/actions/save-rating`, payload)
      .then((data) => {
        return data
      })
  }
}
